// extracted by mini-css-extract-plugin
export var actions = "_sm-4";
export var item = "_sm-1";
export var price = "_sm-3";
export var quantity = "_sm-2";
export var table = "_sm-0";